var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._l(_vm.options, function(option, i) {
      return _c(
        "b-form-radio",
        {
          key: _vm.name + "--" + i,
          attrs: {
            name: _vm.name,
            value: option.value,
            disabled: _vm.disabled,
            inline: !_vm.stacked
          },
          on: {
            change: function($event) {
              return _vm.$emit("change", $event)
            },
            input: function($event) {
              return _vm.$emit("input", $event)
            }
          },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [
          _vm._v("\n\t\t" + _vm._s(option.text) + "\n\t\t"),
          option.info
            ? _c(
                "span",
                {
                  directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
                  staticClass: "ml-1 correct-icon-top-1px",
                  attrs: { title: option.info }
                },
                [_c("Icon", { attrs: { icon: "info" } })],
                1
              )
            : _vm._e()
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }